import React, { Component } from 'react';
import { Col, Row } from 'react-bootstrap';
import AdminLayout from './AdminLayout';
import UserAdminDetail from '../components/admin/UserAdminDetail';
import '../css/style.css';
import '../components/Home.css';

class UserAdminLayout extends Component {

    render(){
        return (
            <AdminLayout eventKey="1">
                <Row>
                    <Col xl={6}>
                    <UserAdminDetail />
                    </Col>
                </Row>
            </AdminLayout>              
        );
    }

}

export default UserAdminLayout;